import { useEffect, useState } from 'react';

import SwitchButton from '~components/SwitchButton';
import { useCompanyInfoMutation } from '~hooks/query/admin/useCompanyPreference';
import useGetCompanyStates from '~hooks/query/company/useCompanyStates';
import { useRouterQuery } from '~hooks/useRouterQuery';
import type { CompanyStates } from '~types/company';

import ButtonAdmin from '../ButtonAdmin';
import Row from '../Row';
import * as S from './style';

type LocalCompanyStates = Partial<Omit<CompanyStates, 'deleted' | 'close' | 'closeAt'>>;

export default function RowDetail() {
  const companyId = useRouterQuery('companyId');
  const { data: originCompanyStates } = useGetCompanyStates(companyId);
  const [companyStates, setCompanyStates] = useState<LocalCompanyStates>();
  const { mutate: handleCompanyInfo } = useCompanyInfoMutation();

  const updateCompanyStates = (newValue: LocalCompanyStates) => {
    setCompanyStates((prevState) => ({ ...prevState, ...newValue }));
  };

  useEffect(() => {
    if (originCompanyStates) {
      const { salary, employee, sales, board, rank } = originCompanyStates;
      setCompanyStates({
        salary,
        employee,
        sales,
        board,
        rank,
      });
    }
  }, [originCompanyStates]);

  if (!companyStates) {
    return null;
  }

  return (
    <Row title={'정보노출'}>
      <S.Column>
        <SwitchButton
          id='admin-preferences-salary'
          label={'연봉'}
          checked={companyStates?.salary}
          onChange={(checked) => {
            updateCompanyStates({ salary: checked });
          }}
        />
      </S.Column>
      <S.Column>
        <SwitchButton
          id='admin-preferences-employee'
          label={'인원'}
          checked={companyStates?.employee}
          onChange={(checked) => {
            updateCompanyStates({ employee: checked });
          }}
        />
      </S.Column>
      <S.Column>
        <SwitchButton
          id='admin-preferences-sales'
          label={'매출'}
          checked={companyStates?.sales}
          onChange={(checked) => {
            updateCompanyStates({ sales: checked });
          }}
        />
      </S.Column>
      <S.Column noMargin>
        <SwitchButton
          id='admin-preferences-board'
          label={'잡담'}
          checked={companyStates?.board}
          onChange={(checked) => {
            updateCompanyStates({ board: checked });
          }}
        />
      </S.Column>
      <S.Divider />
      <S.Column>
        <SwitchButton
          id='admin-preferences-rank'
          label={'홈 랭킹'}
          checked={companyStates?.rank}
          onChange={(checked) => {
            updateCompanyStates({ rank: checked });
          }}
        />
      </S.Column>
      <ButtonAdmin onClick={() => handleCompanyInfo(companyStates)}>{'저장'}</ButtonAdmin>
    </Row>
  );
}
